'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _wrapAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _asyncIterator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CID = require('cids');

var configure = require('../lib/configure');

var normaliseInput = require('ipfs-core-utils/src/pins/normalise-input');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api) {
  return (
    /*#__PURE__*/
    function () {
      var _rmAll = _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(source) {
        var options,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            _value,
            _value3,
            path,
            recursive,
            searchParams,
            res,
            _iteratorNormalCompletion2,
            _didIteratorError2,
            _iteratorError2,
            _iterator2,
            _step2,
            _value2,
            pin,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 3;
                _iterator = _asyncIterator(normaliseInput(source));

              case 5:
                _context.next = 7;
                return _awaitAsyncGenerator(_iterator.next());

              case 7:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 11;
                return _awaitAsyncGenerator(_step.value);

              case 11:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 60;
                  break;
                }

                _value3 = _value, path = _value3.path, recursive = _value3.recursive;
                searchParams = new URLSearchParams(options.searchParams);
                searchParams.append('arg', "".concat(path));
                if (recursive != null) searchParams.set('recursive', String(recursive));
                _context.next = 19;
                return _awaitAsyncGenerator(api.post('pin/rm', {
                  timeout: options.timeout,
                  signal: options.signal,
                  headers: options.headers,
                  searchParams: toUrlSearchParams(_objectSpread({}, options, {
                    arg: "".concat(path),
                    recursive: recursive
                  }))
                }));

              case 19:
                res = _context.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context.prev = 22;
                _iterator2 = _asyncIterator(res.ndjson());

              case 24:
                _context.next = 26;
                return _awaitAsyncGenerator(_iterator2.next());

              case 26:
                _step2 = _context.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context.next = 30;
                return _awaitAsyncGenerator(_step2.value);

              case 30:
                _value2 = _context.sent;

                if (_iteratorNormalCompletion2) {
                  _context.next = 41;
                  break;
                }

                pin = _value2;

                if (!pin.Pins) {
                  _context.next = 36;
                  break;
                }

                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pin.Pins.map(function (cid) {
                  return new CID(cid);
                })), _awaitAsyncGenerator), "t0", 35);

              case 35:
                return _context.abrupt("continue", 38);

              case 36:
                _context.next = 38;
                return new CID(pin);

              case 38:
                _iteratorNormalCompletion2 = true;
                _context.next = 24;
                break;

              case 41:
                _context.next = 47;
                break;

              case 43:
                _context.prev = 43;
                _context.t1 = _context["catch"](22);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 47:
                _context.prev = 47;
                _context.prev = 48;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context.next = 52;
                  break;
                }

                _context.next = 52;
                return _awaitAsyncGenerator(_iterator2.return());

              case 52:
                _context.prev = 52;

                if (!_didIteratorError2) {
                  _context.next = 55;
                  break;
                }

                throw _iteratorError2;

              case 55:
                return _context.finish(52);

              case 56:
                return _context.finish(47);

              case 57:
                _iteratorNormalCompletion = true;
                _context.next = 5;
                break;

              case 60:
                _context.next = 66;
                break;

              case 62:
                _context.prev = 62;
                _context.t2 = _context["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context.t2;

              case 66:
                _context.prev = 66;
                _context.prev = 67;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 71;
                  break;
                }

                _context.next = 71;
                return _awaitAsyncGenerator(_iterator.return());

              case 71:
                _context.prev = 71;

                if (!_didIteratorError) {
                  _context.next = 74;
                  break;
                }

                throw _iteratorError;

              case 74:
                return _context.finish(71);

              case 75:
                return _context.finish(66);

              case 76:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 62, 66, 76], [22, 43, 47, 57], [48,, 52, 56], [67,, 71, 75]]);
      }));

      function rmAll(_x) {
        return _rmAll.apply(this, arguments);
      }

      return rmAll;
    }()
  );
});